import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useRef } from "react"
import styled from "styled-components"

import ProductAddons from "./product-addons"
import WizardActions from "./wizard-actions"
import WizardHeader from "./wizard-header"
import WizardOptions from "./wizard-options"

const Container = styled(Box).attrs((props) => ({
  borderTop: {
    _: `1px solid ${props.theme.colors.grey[10]}`,
    tablet: "none",
  },
  p: { _: "18px 0", tablet: "16px 0 0" },
  ...props,
}))``

const MainBody = ({ outOfStockRef }) => {
  const wizardRef = useRef()

  return (
    <>
      <WizardHeader />
      <section ref={wizardRef}>
        <WizardOptions />
        <ProductAddons />
      </section>
      <Container>
        <WizardActions outOfStockRef={outOfStockRef} wizardRef={wizardRef} />
      </Container>
    </>
  )
}

MainBody.propTypes = {
  outOfStockRef: PropTypes.object,
}

export default MainBody
